// Constructor
function Garden(app) {
	this.app = app;
	this.gardenGame = false;
	this.init();

	this.scenariosData = {};
	this.currentScenarioIndex = 0;
	this.scenariosOrder = [0, 1, 2];
	this.currentScenario = false;

	this.gardenGame = new GardenGame(this);
}

Garden.prototype.init = function () {
	$.ajax({
		url: "garden.html",
		dataType: 'html',
		cache: false,
		complete: $.proxy(function (data, textStatus) {
			$("#game").html(data.responseText);
		}, this)
	});

	$.ajax({
		url: "garden-scenarios.json",
		dataType: 'json',
		cache: false,
		complete: $.proxy(function (data) {
			this.scenariosData = JSON.parse(data.responseText);
		}, this)
	});
}

Garden.prototype.start = function () {
	console.log("starting garden");

	$("#title-screen").fadeOut("normal", function () {
		$("#grid-screen").fadeIn("normal");
	});

	this.reinitScenario();
};


Garden.prototype.reinitScenario = function () {
	this.scenariosOrder = shuffle(this.scenariosOrder);
	this.currentScenarioIndex = 0;
	this.loadScenario();
}

Garden.prototype.gotoStart = function () {

	$("#grid-screen").fadeOut("normal", $.proxy(function () {
		$("#title-screen").fadeIn("normal");

		// if (this.gardenGame) {
		// 	this.gardenGame.reset();
		// }

		// Update left section content
		$("#left-content .specific.intro").removeClass("hide");
		$("#left-content .specific.result").addClass("hide");
		$("#grid").addClass("intro-rotate");

		this.app.reset();

	}, this));
};

Garden.prototype.goToIntro = function () {
	console.log("goToIntro SCREEN")

	if (this.gardenGame) {
		this.gardenGame.reset();
	}

	// Update left section content
	$("#left-content .specific.intro").removeClass("hide hidden");
	$("#left-content .specific.result").addClass("hide");

	$("#right-title .specific.intro").removeClass("hide hidden");
	$("#right-content .specific.intro").removeClass("hide hidden");

	$("#grid").addClass("intro-rotate");
};


Garden.prototype.goToScenario = function () {
	$("#grid").removeClass("intro-rotate").addClass("scenario");

	$("#left-content .specific.intro img").removeClass("shown");

	// Update left section content
	$("#left-content .specific.intro").addClass("hide");
	$("#left-content .specific.scenario").removeClass("hide");
	$("#right-content .specific.scenario .big-button").removeClass("disabled");

	// Update right section content
	this.updateRightContent("intro", "scenario");
};

Garden.prototype.goToAnalyse = function () {

	//disable button
	$("#right-content .specific.scenario .big-button").addClass("disabled");

	$("#left-content .specific.scenario").addClass("hide");
	$("#left-content .specific.analyse").removeClass("hide hidden");

	// Allow analyse object rendering
	$("#grid").removeClass("scenario").addClass("analyse");

	for (var i = 0; i < 9; i++) {

		// Add class
		setTimeout($.proxy(function (i) {
			$("#grid-" + (i + 1) + " .analyse").addClass("shown");

			// 	// Remove class
			// 	setTimeout($.proxy(function (i) {
			// 		$("#grid-" + (i + 1) + " .analyse").removeClass("shown");
			// 	}, this, i), Math.random() * 1000 + 2000);

		}, this, i), Math.random() * 1000);
	}

	// Update right section content
	this.updateRightContent("scenario", "analyse");

};

Garden.prototype.goToGame = function () {

	this.gardenGame.init(this.currentScenario["name"]);

	// Disable analyse object rendering
	$("#grid .grid-element .analyse").removeClass("shown");
	$("#grid").removeClass("analyse");

	// Update right section content
	this.updateRightContent("analyse", "game");

	// Allow analyse object rendering
	$("#grid").removeClass("analyse").addClass("game");

	$("#left-content .specific.analyse").addClass("hide");

	// Show help button
	$("#game #title-bar .help").removeClass("hide");

};

Garden.prototype.goToResult = function () {

	this.gardenGame.endGame();

	var result = this.gardenGame.getResult();
	$("#result-text .fr").html(this.currentScenario["result_" + result + "_text_fr"]);
	$("#result-text .en").html(this.currentScenario["result_" + result + "_text_en"]);

	$("#grid").removeClass("game").addClass("result");
	this.updateRightContent("game", "result");

	// Show help button
	$("#game #title-bar .help").addClass("hide");

};

Garden.prototype.goToInfoBox = function () {

	$("#info-box").removeClass("hidden");

	setTimeout(function () {
		$("#info-box").removeClass("hide");
	}, 50)
};

Garden.prototype.goToNextScenario = function () {

	if ($("#info-box").hasClass("hide")) {
		return;
	}

	$("#info-box").addClass("hide");

	setTimeout($.proxy(function () {
		$("#info-box").addClass("hidden");
		this.currentScenarioIndex++;
		this.updateRightContent("result", "intro");

		if (this.currentScenarioIndex < this.scenariosData["scenarios"].length) {
			this.loadScenario();
			this.goToIntro();
		} else {
			this.gotoStart();
		}

	}, this), 400)

};


Garden.prototype.loadScenario = function () {

	this.currentScenario = this.scenariosData["scenarios"][this.scenariosOrder[this.currentScenarioIndex]];

	// fill in all text fields and images

	$("#main").alterClass("game-scenario-*", "game-scenario-" + this.currentScenario["name"]);
	$("#grid").alterClass("game-scenario-*", "game-scenario-" + this.currentScenario["name"]);

	$("#left-content .specific.intro img").attr("src", this.currentScenario["intro_img"]).addClass("shown");

	$("#game-scenario-title .en").html(this.currentScenario["scenario_title_en"]);
	$("#game-scenario-title .fr").html(this.currentScenario["scenario_title_fr"]);
	$("#game-scenario-text .en").html(this.currentScenario["scenario_text_en"]);
	$("#game-scenario-text .fr").html(this.currentScenario["scenario_text_fr"]);

	$("#game-title .en").html(this.currentScenario["game_title_en"]);
	$("#game-title .fr").html(this.currentScenario["game_title_fr"]);
	$("#game-text .en").html(this.currentScenario["game_text_en"]);
	$("#game-text .fr").html(this.currentScenario["game_text_fr"]);

	$("#result-title .en").html(this.currentScenario["result_title_en"]);
	$("#result-title .fr").html(this.currentScenario["result_title_fr"]);
	$("#result-text .en").html(this.currentScenario["result_text_en"]);
	$("#result-text .fr").html(this.currentScenario["result_text_fr"]);

	$("#info-box h2.en").html(this.currentScenario["conclusion_title_en"]);
	$("#info-box h2.fr").html(this.currentScenario["conclusion_title_fr"]);
	$("#info-box p.en").html(this.currentScenario["conclusion_text_en"]);
	$("#info-box p.fr").html(this.currentScenario["conclusion_text_fr"]);

	$("#right-content .specific.game .gauge").removeClass("shown");
	$("#right-content .specific.game .gauge.game-scenario-" + this.currentScenario["name"]).addClass("shown");
};


Garden.prototype.updateRightContent = function (outClass, inClass) {

	$("#right-content").addClass("moveOut");
	$("#right-content .specific." + outClass).addClass("hide");

	$("#right-title").addClass("moveOut");
	$("#right-title .specific." + outClass).addClass("hide");

	setTimeout(function () {
		$("#right-content .specific." + outClass).addClass("hidden");
		$("#right-content .specific." + inClass).removeClass("hide hidden");
		$("#right-content").removeClass("moveOut");

		$("#right-title .specific." + outClass).addClass("hidden");
		$("#right-title .specific." + inClass).removeClass("hide hidden");
		$("#right-title").removeClass("moveOut");

	}, 700)

}

Garden.prototype.closeHelp = function (s) {

	$("#help").addClass("hide");

	setTimeout(function () {
		$("#help").addClass("hidden");
	}, 700)
}

Garden.prototype.showHelp = function (s) {

	$("#help").removeClass("hidden");

	setTimeout(function () {
		$("#help").removeClass("hide");
	}, 50)
}

Garden.prototype.reset = function () {

	// Resset is called when returning to screensaver

	// Close help
	this.closeHelp();

	// Reset scenario
	this.reinitScenario();

	// Animate in/out and reset classes
	$("#grid-screen").fadeOut("normal", $.proxy(function () {

		$("#left-content .specific").addClass("hide hidden");
		$("#right-title .specific").addClass("hide hidden");
		$("#right-content .specific").addClass("hide hidden");
		$("#info-box").addClass("hidden");

		// Back to intro
		this.goToIntro();

		// Bring title screen
		$("#title-screen").fadeIn("normal");

	}, this));

};

// Expose Garden
window.Garden = Garden;
